import { render, staticRenderFns } from "./invitationCard.vue?vue&type=template&id=0d639052&scoped=true&"
import script from "./invitationCard.vue?vue&type=script&lang=js&"
export * from "./invitationCard.vue?vue&type=script&lang=js&"
import style0 from "./invitationCard.vue?vue&type=style&index=0&id=0d639052&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d639052",
  null
  
)

export default component.exports